var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text-center py-3"},[_c('p',{staticClass:"p--big mb-0 fw-700"},[_vm._t("default"),_c('small',{staticClass:"mb-0",staticStyle:{"display":"block"}},[_vm._v(_vm._s(_vm.label))])],2),_vm._t("outerText")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }